import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;